/**
 * Bayide KALDIRILAN izinler — Server `dealer-permissions.config.js`
 * `RETIRED_PERMISSION_KEYS` ile aynı cihaz anahtarları.
 *
 * Eski rol şablonlarında/kullanıcılarda hâlâ durabilirler; bayi rolündeki
 * kullanıcı için `usePermission` bunları HİÇ YOKMUŞ gibi sayar. Böylece
 * panelde bayiye kapatılan özellik izinle değil rolle kapanır (her ekranda
 * ayrı `isDealer` kapısı gerekmez).
 *
 *   #178 manuel kota · #180 son işlem · #302 versiyon/GSM kartı, hareket,
 *   ayarlar (+ bakım) sekmeleri, bilgi değişiklik logları
 */
export const DEALER_RETIRED_PERMISSIONS = new Set([
  "devices.quota",
  "devices.lastOperation",
  "devices.infoVersion",
  "devices.infoGsm",
  "devices.movement",
  "devices.settings",
  "devices.maintenance",
  "devices.reportInfo",
]);
